import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Link } from 'react-router-dom'
import { Flex, Heading, Button } from '@pancakeswap/uikit'
import { useWeb3React } from '@web3-react/core'
import { useTranslation } from 'contexts/Localization'
import ConnectWalletButton from 'components/ConnectWalletButton'
import useTheme from 'hooks/useTheme'

import CompositeImage, { getSrcSet, CompositeImageProps } from './CompositeImage'
import useGetTopFarmsByApr from '../hooks/useGetTopFarmsByApr'
import useGetTopPoolsByApr from '../hooks/useGetTopPoolsByApr'


const flyingAnim = () => keyframes`
  from {
    transform: translate(0,  0px);
  }
  50% {
    transform: translate(-5px, -5px);
  }
  to {
    transform: translate(0, 0px);
  }
`

const fading = () => keyframes`
  from {
    opacity: 0.9;
  }
  50% {
    opacity: 0.1;
  }
  to {
    opacity: 0.9;
  }
`

const BgWrapper = styled.div`
  z-index: -1;
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0px;
  left: 0px;
`

const InnerWrapper = styled.div`
  position: absolute;
  width: 100%;
  bottom: -3px;
`

const BunnyWrapper = styled.div`
  width: 100%;
  animation: ${flyingAnim} 3.5s ease-in-out infinite;
`

const StarsWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  & :nth-child(2) {
    animation: ${fading} 2s ease-in-out infinite;
    animation-delay: 1s;
  }

  & :nth-child(3) {
    animation: ${fading} 5s ease-in-out infinite;
    animation-delay: 0.66s;
  }

  & :nth-child(4) {
    animation: ${fading} 2.5s ease-in-out infinite;
    animation-delay: 0.33s;
  }
`

const imagePath = '/images/home/lunar-bunny/'
const newSpaceDog ='/images/home/lunar-bunny/space_dog.png'
const logo ='/images/home/lunar-bunny/rise.jpg'

const androidbtnn = "<img src='/images/androidbutton.png' />"
const imageSrc = 'bunny'

const starsImage: CompositeImageProps = {
  path: '/images/home/lunar-bunny/',
  attributes: [
    { src: 'star-l', alt: '3D Star' },
    { src: 'star-r', alt: '3D Star' },
    { src: 'star-top-r', alt: '3D Star' },
  ],
}

const Hero = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { theme } = useTheme()


    const totalLocked = 0;
     // if(topFarms && topFarms.length > 0){
     //   console.log(topFarms,"topFarms")
     //   if(topFarms[0] && topFarms[1] && topFarms[2] && topFarms[3] && topFarms[4] && topFarms[5] &&  topPools[0] && topPools[1] && topPools[2] && topPools[3]){
     //     const totalLiquidity1 = topFarms[0].lpTotalInQuoteToken.times(topFarms[0].quoteTokenPriceBusd)
     //     const totalLiquidity2 = topFarms[1].lpTotalInQuoteToken.times(topFarms[1].quoteTokenPriceBusd)
     //     const totalLiquidity3 = topFarms[2].lpTotalInQuoteToken.times(topFarms[2].quoteTokenPriceBusd)
     //     const totalLiquidity4 = topFarms[3].lpTotalInQuoteToken.times(topFarms[3].quoteTokenPriceBusd)
     //     const totalLiquidity5 = topFarms[4].lpTotalInQuoteToken.times(topFarms[4].quoteTokenPriceBusd)
     //     const totalLiquidity6 = topFarms[5].lpTotalInQuoteToken.times(topFarms[5].quoteTokenPriceBusd)
     //
     //     const totalPool1 = topPools[0].totalStaked.times(topPools[0].stakingTokenPrice).div(1000000000000000000);
     //     const totalPool2 = topPools[1].totalStaked.times(topPools[1].stakingTokenPrice).div(1000000000000000000);
     //     const totalPool3 = topPools[2].totalStaked.times(topPools[2].stakingTokenPrice).div(1000000000000000000);
     //     const totalPool4 = topPools[3].totalStaked.times(topPools[3].stakingTokenPrice).div(1000000000000000000);
     //
     //      totalLocked = parseFloat(totalLiquidity1.toLocaleString())+parseFloat(totalLiquidity2.toLocaleString())+parseFloat(totalLiquidity3.toLocaleString())+parseFloat(totalLiquidity4.toLocaleString())+parseFloat(totalLiquidity5.toLocaleString())+parseFloat(totalLiquidity6.toLocaleString())+parseFloat(totalPool1.toLocaleString())+parseFloat(totalPool2.toLocaleString())+parseFloat(totalPool3.toLocaleString())+parseFloat(totalPool4.toLocaleString());
     //   }
     // }



  return (
    <>
      <section className="bannerTop">
        <div className='container'>
          <div className='row'>
            <div className='col-md-7 flexColumn'>
              <h1 className="elementor-heading-title"><span>A one-stop shop for your finances.</span>Designed to work better together.</h1>
              <h6>
                Bridging the gap between regulated financial services and the world of blockchain
              </h6>
              {/* <div className='bannerAppButton'>
                  <a href="https://play.google.com/store/apps/details?id=com.newmedia.rise" target='blank'>
                    <img src="/images/androidbutton.png" alt="" />
                  </a>
                  <a href="https://apps.apple.com/us/app/risebank/id1617249895" target='blank'>
                  <img src="/images/appstorebutton.png" alt="" />
                  </a>
              </div> */}
            </div>
            <div className='col-md-5'>
              <img src="/images/bannerimg.png" alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      <Flex
        position="relative"
        flexDirection={['column-reverse', null, null, 'row']}
        alignItems={['flex-end', null, null, 'center']}
        justifyContent="center"
        mt={[account ? '280px' : '50px', null, 0]}
        id="homepage-hero"
      >
        <Flex flex="1" flexDirection="column">
          <div className="clas_img_img d-none">
          <h3 className="top_headein_ss">{t('totalvaluelocked')} ${totalLocked.toLocaleString('en', { maximumFractionDigits: 0 })} {t('allLp')}</h3>
          </div>
        </Flex>
      </Flex>
    </>
  )
}

export default Hero
